import React from "react";
import { CategoriesUIProvider } from "./CategoriesUIContext";
import CategoriesCard from "./Categories";

export function CategoriesPage({ history }) {

  const categoriesUIEvents = {
  
    openEditCategoryPage: (id,total) => {
      history.push(`/app/categories/${id}/${total}/edit`);
    },
   
  };
  return (
    <CategoriesUIProvider categoriesUIEvents={categoriesUIEvents}>
     
      <CategoriesCard />
    </CategoriesUIProvider>
  );
}
